import styled from '@emotion/styled';
import Icon from 'presentations/views/components/atoms/Icon';
import Headline from 'presentations/views/components/atoms/Headline';
import { spacing, fontSize, mediaMax } from 'presentations/views/styles';
import { primary } from 'presentations/views/styles/color';
import { ReactNode } from 'react';

interface Props {
  icon: string;
  iconClass?: string;
  title: string;
  description?: string;
  tab?: ReactNode;
}

export default function Component(props: Props) {
  return (
    <>
      <ContentHeader>
        <ContentHeaderContainer>
          <TitleContainer>
            <HeaderIcon
              name={props.icon}
              className={props.iconClass}
              size={fontSize(36)}
            />
            <Headline variant="h1">{props.title}</Headline>
          </TitleContainer>
          {props.description && <HeaderText>{props.description}</HeaderText>}
        </ContentHeaderContainer>
      </ContentHeader>
      {props.tab && <TabContainer>{props.tab}</TabContainer>}
    </>
  );
}

const HeaderIcon = styled(Icon)`
  margin-right: ${spacing(8)};
  color: ${primary};
  font-size: ${fontSize(32)};
  ${mediaMax.tablet} {
    font-size: ${fontSize(24)};
  }
`;
const HeaderText = styled.p`
  /* font-size: ${fontSize(12)}; */
  margin-top: ${spacing(8)};
`;

const ContentHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin: 0 auto;
  padding: ${spacing(56)} 0 ${spacing(64)};
  ${mediaMax.smartphone} {
    padding: ${spacing(32)} 0;
  }
`;
const ContentHeaderContainer = styled.div``;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TabContainer = styled.div`
  /* width: 960px; */
  margin: 0 auto;
  ${mediaMax.tablet} {
  }
`;
